import React, { createContext, useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'zinihub_darkMode';

const getInitialDarkMode = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored !== null) return stored === 'true';
  if (window.matchMedia?.('(prefers-color-scheme: dark)').matches) return true;
  return false;
};

export const DarkModeContext = createContext();

export const DarkModeProvider = ({ children }) => {
  const [darkMode, setDarkModeState] = useState(getInitialDarkMode);

  const setDarkMode = useCallback((next) => {
    const value = typeof next === 'function' ? next(darkMode) : next;
    localStorage.setItem(STORAGE_KEY, String(value));
    setDarkModeState(value);
  }, [darkMode]);

  useEffect(() => {
    document.body.classList.toggle('darkMode', darkMode);
  }, [darkMode]);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e) => {
      if (localStorage.getItem(STORAGE_KEY) === null) {
        setDarkModeState(e.matches);
      }
    };
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return (
    <DarkModeContext.Provider value={{ darkMode, setDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
};
